import {useState} from "react";
import FolderIcon from "@mui/icons-material/Folder";
import {Box, Tab, Tabs} from "@mui/material";
import {useTranslation} from "react-i18next";
import {getPackagesInternalUrl} from "../../constants/appRoutes";
import CardsGrid from "../cards-grid";

const CatalogPreview = ({node, catalog, baseURL}) => {
  const {t} = useTranslation();

  const [categorySchemeTab, setCategorySchemeTab] = useState(0);

  const nodeExtras = node?.extras || [];
  const hideLabelOnCategoryWithImage = JSON.parse(
    nodeExtras.find(({key}) => key === "HideLabelOnCategoryWithImage")?.value || "[]"
  );

  const uncategorizedCategory = {
    id: "uncategorized",
    label: t("commons.catalog.uncategorized"),
    childrenCategories: [],
    packageIdentifiers: catalog?.uncategorizedPackages
  };

  const categories = catalog
    ? catalog.categoryGroups.length > 1
      ? categorySchemeTab === "uncategorized"
        ? [uncategorizedCategory]
        : catalog.categoryGroups[categorySchemeTab].categories.map(c => ({
            ...c,
            image: c.image ? baseURL + c.image : undefined
          }))
      : catalog.uncategorizedPackages.length > 0
        ? catalog.categoryGroups[0]?.categories
            .map(c => ({
              ...c,
              image: c.image ? baseURL + c.image : undefined
            }))
            .concat([uncategorizedCategory]) || [uncategorizedCategory]
        : catalog.categoryGroups[0]?.categories.map(c => ({
            ...c,
            image: c.image ? baseURL + c.image : undefined
          })) || []
    : [];

  const categoriesWithImages = (categories || []).find(({image}) => !!image) !== undefined;

  return (
    catalog && (
      <Box id="catalog-preview__content">
        {catalog.hasCategorySchemes && (
          <Tabs
            value={categorySchemeTab}
            variant="scrollable"
            scrollButtons="auto"
            onChange={(_, tab) => setCategorySchemeTab(tab)}
            sx={{
              marginBottom: theme => theme.spacing(2),
              "& .MuiTab-root.Mui-selected": {
                color: theme => theme.palette.text.primary
              }
            }}
            slotProps={{
              indicator: {
                sx: {
                  backgroundColor: theme => theme.palette.text.primary
                }
              }
            }}
          >
            {catalog.categoryGroups.map(({label}, index) => (
              <Tab key={index} value={index} label={label} tabIndex={0} />
            ))}
            {catalog.uncategorizedPackages?.length > 0 && (
              <Tab key="uncategorized" value="uncategorized" label={t("commons.catalog.uncategorized")} tabIndex={0} />
            )}
          </Tabs>
        )}
        <CardsGrid
          list={categories}
          getHref={category =>
            getPackagesInternalUrl(
              node?.code,
              category.id === "uncategorized"
                ? ["uncategorized"]
                : catalog.hasCategorySchemes
                  ? [catalog.categoryGroups[categorySchemeTab].id, category.id]
                  : [category.id]
            )
          }
          hideLabelOnElemWithImage={hideLabelOnCategoryWithImage}
          icon={<FolderIcon />}
          size={{
            xs: categoriesWithImages ? 4 : 12,
            sm: categoriesWithImages ? 4 : 12,
            md: categoriesWithImages ? 3 : 6,
            lg: categoriesWithImages ? 2 : 4,
            xl: categoriesWithImages ? 2 : 4
          }}
        />
      </Box>
    )
  );
};

export default CatalogPreview;
